import { observer } from 'mobx-react';
import { T } from '../../../../../../Translations';

interface Props {
  totalShareUrlCount: number;
  filteredShareUrlCount: number;
}

function DisplayedCount({ totalShareUrlCount, filteredShareUrlCount }: Props) {
  return (
    <div className="max-w-clientPortalMaxWidth px-2.5 lg:px-12 text-sm my-8">
      <T
        kind="Showing {{filteredCount}} out of {{totalCount}} Program Deep Links"
        totalCount={totalShareUrlCount}
        filteredCount={filteredShareUrlCount}
      />
    </div>
  );
}

export default observer(DisplayedCount);
